import { Component, Vue } from 'vue-property-decorator';
import { Order } from '@/models/Order';
import { Contact as ContactModel } from '@/models/Contact';
import { User } from '@/models/User';
import { UserFile } from '@/models/UserFile';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { customFilter } from '@/views/Users/Users';

@Component<OrderFees>({})
export default class OrderFees extends Vue {
  public $pageTitle = 'Order fees';
  private type: string | null = null;
  protected selected: any[] = [];
  protected contact: ContactModel = new ContactModel();
  protected contactImages: any[] = [];
  protected statusOptions: any[] = [{
    text: 'Draft',
    value: 'draft',
    type: 'status',
  }, {
    text: 'Completed',
    value: 'completed',
    type: 'status',
  }];

  protected filters: customFilter = {
    type: 'custom',
    items: this.statusOptions,
  };

  public mounted() {
    // @ts-ignore
    this.type = this.$route.meta.type;
    this.$root.$emit('breadcrumbUpdated',
    {
        crumb: [
          // @ts-ignore
          { name: this.$route.meta.name },
        ],
      }
    );
  }

  get tableOptions() {
    const sourceMap: any = {
      OrderFees: {
        name: {
          singular: 'SaleOrder',
          plural: 'SaleOrders',
        },
        sort: {
          key: 'created_at',
          order: 'DESC',
        },
        headers: [
          {
            text: 'Name',
            value: 'user',
            transform: (user: User) => {
              return user.name
            },
            action: '/styling-fees/{id}',
          },
          {
            text: 'Email',
            value: 'user',
            transform: (user: User) => {
              return user.email
            },
          },
          {
            text: 'Aangemaakt op',
            value: 'created_at',
            sortable: {
              key: 'created',
              order: 'ASC',
            },
          },
          {
            text: 'Order ID',
            value: 'id',
          },
          {
            text: 'Tradegecko ID',
            value: 'tradegecko_id',
          },
        ],
        actions: [
          {
            type: 'view',
            label: 'view',
            icon: 'remove_red_eye',
          action: '/styling-fees/{id}',
          },
        ],
        model: new Order().include(['user', 'order-items', 'payments']).filter({type: 'payments'}),
      },
    };
    return sourceMap[this.type as string];
  }

  protected getContact(order: any) {
    new ContactModel()
    .include(['profile', 'answers'])
    .find(order.user.id)
    .then((contact: ContactModel) => {
      this.contact = contact;

      if(!this.contact.profile || !this.contact.profile.answers) {
        return;
      }

      this.contact.profile.answers = JSON.parse((this.contact.profile as any).answers);
      this.contact.answers = [...(this.contact.profile as any).answers];
      this.redirectToOrder(order);
    });
    this.fetchFiles(order);
  }

  protected fetchFiles(order: any) {
    new UserFile()
    .user(order.user.id)
    .limit(100)
    .all()
    .then((images: any) => {
      this.contact.images = images;
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    })
  }

  protected redirectToOrder(order: any) {
    this.$router.push({
      name: 'webshop.order',
      params: { contact: (this.contact as any), id: order.id }
  });
  }
}
